// propsViewerService.js
// Service for picks viewer API calls.

import { GET, POST, BASE_URL } from './httpClient';

export const getPropsViewerSports = async () => {
    try {
        return await GET(`${BASE_URL}/props-viewer/sports`);
    } catch (error) {
        console.error('Error fetching props viewer sports:', error);
        throw error;
    }
};

export const getPropsViewerOptions = async (sport) => {
    try {
        return await POST(`${BASE_URL}/props-viewer/options`, { sport });
    } catch (error) {
        console.error('Error fetching props viewer options:', error);
        throw error;
    }
};

export const getPropsViewerBets = async ({
    sport,
    propMarketTypes = [],
    confidenceLevels = [],
    player = '',
    page = 1,
    pageSize = 25
} = {}) => {
    try {
        const request = {
            page,
            pageSize
        };

        if (sport) request.sport = sport;
        if (propMarketTypes.length > 0) request.propMarketTypes = propMarketTypes;
        if (confidenceLevels.length > 0) request.confidenceLevels = confidenceLevels;
        if (player.trim()) request.player = player.trim();

        return await POST(`${BASE_URL}/props-viewer/bets`, request);
    } catch (error) {
        console.error('Error fetching props viewer bets:', error);
        throw error;
    }
};

export const generateBetLink = async ({
    source,
    sourcePayload,
    bookmakerKey,
    state = '',
    allowClosestLine = true,
    excludeDfs = true,
    includeDetails = false,
    persist = true,
    legs = []
} = {}) => {
    try {
        const request = {
            bookmakerKey,
            allowClosestLine,
            excludeDfs,
            includeDetails,
            persist,
            legs
        };

        if (source) {
            request.source = source;
        }

        if (sourcePayload && Object.keys(sourcePayload).length > 0) {
            request.sourcePayload = sourcePayload;
        }

        if (state) {
            request.state = state;
        }

        return await POST(`${BASE_URL}/bet-links`, request);
    } catch (error) {
        console.error('Error generating bet link:', error);
        throw error;
    }
};

export const generatePropsViewerBetLink = generateBetLink;

export const getBetRecommendations = async ({
    sport = '',
    sports = [],
    betTypes = [],
    propMarketTypes = [],
    propDirections = []
} = {}) => {
    try {
        const request = {};

        if (sport) request.sport = sport;
        if (Array.isArray(sports) && sports.length > 0) request.sports = sports;
        if (Array.isArray(betTypes) && betTypes.length > 0) request.betTypes = betTypes;
        if (Array.isArray(propMarketTypes) && propMarketTypes.length > 0) request.propMarketTypes = propMarketTypes;
        if (Array.isArray(propDirections) && propDirections.length > 0) request.propDirections = propDirections;

        return await POST(`${BASE_URL}/bet-recommendations`, request);
    } catch (error) {
        console.error('Error fetching bet recommendations:', error);
        throw error;
    }
};
